
import postcssStyledJsxUrlLoader_0 from '../../images/loading.svg';
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.cta-link {
  @include button;
  position: relative;

  svg {
    margin-left: 8px;
    vertical-align: middle;
    margin-top: -2px;
  }

  &--loading {
    pointer-events: none;

    &::before {
      content: '';
      display: block;
      position: absolute;
      left: calc(50% - 12px);
      width: 24px;
      height: 24px;
      background-image: url("${postcssStyledJsxUrlLoader_0}");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 24px 24px;
      animation: spin 0.6s infinite linear;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .button-content {
      visibility: hidden;
    }
  }

  &__icon {
    vertical-align: middle;
  }

  &.cta-link--unstyled {
    display: inline-block;
    border-radius: none;
    padding: 0;
    -webkit-text-decoration: none;
    text-decoration: none;
    text-align: unset;
    transition: unset;
    cursor: pointer;
    background-color: unset;
    border: none;
    color: unset;
  }
}
`